      <nav class="navbar navbar-expand-md navbar-custom fixed-top">
        <div class="container-fluid px-3 px-md-5" style="overflow: visible;">
          <!-- Brand Logo -->
          <a routerLink="/home" class="navbar-brand navbar-logo">
            <img src="../../../assets/images/Solar Academy 2.png" alt="SolarTaxi Academy Logo" class="logo-img img-fluid"/>
          </a>

          <!-- Mobile Toggler Button -->
          <button class="navbar-toggler" type="button" (click)="toggleMenu()" [attr.aria-expanded]="showMenu" aria-controls="navbarContent" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Navbar Content -->
          <div class="collapse navbar-collapse" id="navbarContent" [class.show]="showMenu">
            <!-- Navigation Links -->
            <ul class="navbar-nav ms-auto align-items-center">
              <li class="nav-item">
                <a routerLink="/gallery" (click)="closeMenu()" class="nav-link nav-link-custom" routerLinkActive="active">
                  <span class="nav-icon fa fa-images"></span>
                  <span class="nav-text">Gallery</span>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/fea-application" (click)="closeMenu()" class="nav-link nav-link-custom" routerLinkActive="active">
                  <span class="nav-icon fa fa-images"></span>
                  <span class="nav-text">FEA Application</span>
                </a>
              </li>

               <!-- Student panel link (visible to students only) -->
              <li class="nav-item" *ngIf="authService.isLearner()">
                <a routerLink="/dashboard" class="nav-link nav-link-custom" routerLinkActive="active">
                  <span class="nav-icon fa fa-user-shield"></span>
                  <span class="nav-text">Student: Dashboard</span>
                </a>
              </li>

              <!-- Admin panel link (visible to admins only) -->
              <li class="nav-item" *ngIf="authService.isAdmin()">
                <a routerLink="/admin/fea-applications" class="nav-link nav-link-custom" routerLinkActive="active">
                  <span class="nav-icon fa fa-user-shield"></span>
                  <span class="nav-text">Admin: Applications</span>
                </a>
              </li>
              <li class="nav-item" *ngIf="authService.isAdmin()">
                <a routerLink="/signup" class="nav-link nav-link-custom" routerLinkActive="active">
                  <span class="nav-icon fa fa-user-shield"></span>
                  <span class="nav-text">Signup Students</span>
                </a>
              </li>

              <!-- Auth Button / Logout -->
              <li class="nav-item ms-2" *ngIf="!authService.hasUser">
                <button class="btn btn-login btn-block-sm" (click)="closeMenu()" data-toggle="modal" data-target="#loginModal" type="button">
                  <span class="fa fa-sign-in me-2"></span>
                  <span class="btn-text">Login</span>
                </button>
              </li>
              <li class="nav-item ms-2" *ngIf="authService.hasUser">
                <button class="btn btn-secondary btn-block-sm" (click)="authService.SignOut(); closeMenu();" type="button">
                  <span class="fa fa-sign-out me-2"></span>
                  <span class="btn-text">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      <div class="dashboard-navbar-header" *ngIf="isDashboardRoute && authService.hasUser">
        <p class="text-muted mb-0">Welcome back, <strong>{{ user.displayName }}</strong></p>
      </div>
    </nav>

          <!-- login modal -->
    <div id="loginModal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg" role="content">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title">Login</h4>
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body">
                  <form #form="ngForm" (ngSubmit)="login(form)">
                      <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label class="sr-only" for="email">Email address</label>
                                <input type="email" name="email" class="form-control form-control-sm mr-1" id="email" placeholder="Enter email" [(ngModel)]="data.email" required>
                            </div>
                            <div class="form-group col-sm-4">
                              <label class="sr-only" for="password">Password</label>
                              <div class="input-group">
                                <input [type]="isPasswordVisible ? 'text' : 'password'" name="password" class="form-control form-control-sm mr-1" id="password" placeholder="Password" [(ngModel)]="data.password" required>
                                <span class="input-group-text" role="button" tabindex="0" (click)="togglePasswordVisibility()" (keydown.enter)="togglePasswordVisibility()" (keydown.space)="togglePasswordVisibility()" [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"><i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'"></i>                              </span>
                              </div>
                            </div>      <div class="col-sm-auto">
                              <div class="form-check">
                                  <input class="form-check-input" type="checkbox">
                                  <label class="form-check-label"> Remember me
                                  </label>
                                  <br>
                                 <a routerLink="/forgot-password">Forgot Password?</a>
                              </div>
                          </div>
                      </div>
                        <div class="form-row d-flex gap-2 justify-content-end">
                          <button type="button" class="btn btn-secondary btn-sm btn-block-sm" data-dismiss="modal">Cancel</button>
                          <button type="submit" class="btn btn-primary btn-sm btn-block-sm">Sign in</button>
                        </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  


